export default "__VITE_PUBLIC_ASSET__b371213f__"